import React from 'react';
import {Box, Typography} from '@material-ui/core';

function Reports() {
  return (
    <Box className="reports-container">
      <Typography variant="h6" gutterBottom>
        AI Bookkeeper Reports
      </Typography>
      <Typography variant="body1">
        This is dummy data for the Reports tab. Add charts, graphs, or other
        analytical views of your financial data here.
      </Typography>
    </Box>
  );
}

export default Reports;
